import { createReducer, on, createAction, props, Action } from '@ngrx/store';

export const LAYOUT_FEATURE_KEY = 'layout';

export interface LayoutState {
  showMenuMain: string;
  language: string;
}

export interface LayoutPartialState {
  readonly [LAYOUT_FEATURE_KEY]: LayoutState;
}

/** Action dispatched to change the active language. */
export const changeLanguage = createAction(
  '[Layout] Change Language',
  props<{ language: string }>()
);

/** Action dispatched to set the main menu visibility state. */
export const actionMainMenu = createAction(
  '[Layout] Action Main Menu',
  props<{ action: string }>()
);

export const initialLayoutState: LayoutState = {
  showMenuMain: window.innerWidth < 600 ? 'closed' : 'open',
  language: 'es',
};

const reducer = createReducer(
  initialLayoutState,
  on(actionMainMenu, (state, { action }) => ({
    ...state,
    showMenuMain: action,
  })),
  on(changeLanguage, (state, { language }) => ({
    ...state,
    language,
  }))
);

/**
 * Root reducer function for the layout feature state.
 * @param state - The current layout state
 * @param action - The dispatched action
 * @returns The next layout state
 */
export function layoutReducer(state: LayoutState | undefined, action: Action) {
  return reducer(state, action);
}
